import { Pipe, PipeTransform } from 'ng-metadata/core';
import { element, isDefined } from 'angular';

/**
 * @ngdoc filter
 * @name mwLinkyHtml
 * @module mw.components.contentDocuments
 *
 * @param {string} [html] - The HTML you want to be turned into a link
 * @param {string} [target] - Specify where you want to open the linked document EX: '_blank, _self, _parent'
 * @returns {string}
 *
 * @description
 * `mwLinkyHtml` transforms your HTML into a link
 */
@Pipe({
    name: 'mwLinkyHtml'
})
export class LinkyHtmlPipe implements PipeTransform {


    transform(text: string, target: string) {
        const LINKY_URL_REGEXP: RegExp = /((ftp|https?):\/\/|(mailto:)[A-Za-z0-9._%+-]+@|www\.([^\s.;,(){}<>"]+\.)+|([^\s.;,(){}<>"]+\.)+[^\s.;,(){}<>"0-9]+\/)[A-Za-z0-9-._~:\/?#\[\]@!$&'()*+,;=<>]*[^\s.;,(){}<>"]*/i;
        const LINKY_PROTOCOL_REGEXP: RegExp = /^http[s]?\:\/\//i;
        const MAILTO_REGEXP: RegExp = /^mailto:/;
        const ELIPSIS_REGEXP: RegExp = /\u2026/i;

        let match;
        let raw = text;
        let html = [];
        let url;
        let originalMatch;
        let i;

        target = target || '_blank';
        if (!text) return text;

        match = raw.match(LINKY_URL_REGEXP);
        while (match) {
            // We can not end in these as they are sometimes found at the end of the sentence
            originalMatch = match[0];
            url = addProtocol(removeTags(match[0]));
            i = match.index;
            addText(raw.substr(0, i));

            // Some matches may be truncated (tweets) let's not
            // link partial URLs (they'll be broken)
            // JavaScript does not support negative look-behinds so...
            if (url.slice(-1).match(ELIPSIS_REGEXP) !== null) {
                addText(originalMatch);
            } else {
                addLink(url, originalMatch.replace(MAILTO_REGEXP, ''));
            }

            raw = raw.substring(i + match[0].length);
            match = raw.match(LINKY_URL_REGEXP);
        }
        addText(raw);

        return html.join('');

        function removeTags(text) {
            let c = element('<p>' + text + '</p>');
            return c.text();
        }

        function addText(text) {
            if (!text) {
                return;
            }
            html.push(text);
        }

        function addProtocol(url) {
            if (!LINKY_PROTOCOL_REGEXP.test(url) && !MAILTO_REGEXP.test(url)) {
                url = 'http://' + url;
            }

            return url;
        }

        function addLink(url, text) {
            html.push('<a ');
            if (isDefined(target)) {
                html.push('target="');
                html.push(target);
                html.push('" ');
            }
            html.push('href="');
            html.push(url);
            html.push('">');
            addText(text);
            html.push('</a>');
        }
    };
}


// WEBPACK FOOTER //
// ./src/lib/components/content-documents/shared/linky-html.pipe.ts